import Vue from 'vue'
import VueRouter from 'vue-router'
const index = () => import('../view/login')
const checkToken = () => import('../view/checkToken')


// 消息推送 push
const push = () => import('../view/push/content')
const pushFire = () => import('../view/push/areal/fire')
const pushAbnormal = () => import('../view/push/industrial/abnormal')
const pushdecannulation = () => import('../view/push/industrial/decannulation')
const pushlist = () => import('../view/push/industrial/list')
const pushlow = () => import('../view/push/industrial/low')
const pushmiss = () => import('../view/push/industrial/miss')
const pushoxygen = () => import('../view/push/industrial/oxygen')
const pushvariation = () => import('../view/push/industrial/variation')
const pushcar = () => import('../view/push/move/car')
const pushgasStat = () => import('../view/push/move/gasStat')
const pushsys = () => import('../view/push/sys/sys')


Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

let router = new VueRouter({
    base: '',
    mode:"history",
  routes: [
    {path: '/', name: 'index', component: index},

    {path: '/checkToken', name: 'checkToken', component: checkToken},
      {path:'/push',name:'push',component:push,children:[
              {path:'fire',name:'pushFire',component:pushFire},
              {path:'abnormal',name:'pushAbnormal',component:pushAbnormal},
              {path:'decannulation',name:'pushdecannulation',component:pushdecannulation},
              {path:'list',name:'pushlist',component:pushlist},
              {path:'low',name:'pushlow',component:pushlow},
              {path:'miss',name:'pushmiss',component:pushmiss},
              {path:'oxygen',name:'pushoxygen',component:pushoxygen},
              {path:'variation',name:'pushvariation',component:pushvariation},
              {path:'car',name:'pushcar',component:pushcar},
              {path:'gasStat',name:'pushgasStat',component:pushgasStat},
              {path:'sys',name:'pushsys',component:pushsys},
          ]}
  ]
})

router.beforeEach((to, from, next) => {
    if(to.query.verificationToken){
        if(to.name){
            console.log(to.path)
            localStorage.setItem('verificationToken2Router',to.path)
        }
        next({name:'verificationToken2',query:{token:to.query.verificationToken}})
    }else {
        next()
    }
})

export default router
